var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.998 11.47l2.237 2.234a1.01 1.01 0 001.43 0l2.237-2.233a1.011 1.011 0 00-1.43-1.428l-.522.52V2.998a.998.998 0 00-1-.998c-.553 0-1 .446-1 .998v7.565l-.522-.52a1.01 1.01 0 00-1.43 0 1.006 1.006 0 000 1.428z",
    fill: "currentColor"
  })));
}
export default SvgSortDown;